import { render, staticRenderFns } from "./leaveLossForm.vue?vue&type=template&id=627d5bba"
import script from "./leaveLossForm.vue?vue&type=script&lang=js"
export * from "./leaveLossForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports